'use client';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/material';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const LoadingSpinner = styled('div')`
  display: block;
  width: 16px;
  height: 16px;
  position: absolute;
  border-radius: 50%;
  border: 2px solid transparent;
  border-color: transparent transparent rgba(25, 25, 25, 0.1) rgba(25, 25, 25, 0.1);
  right: 20px;
  top: calc(50% - 8px - 4px);
  transform-origin: 50% 50%;
  animation: ${spin} 0.4s linear infinite;
`;
